import { createAsyncThunk } from "@reduxjs/toolkit";

import { MeasurementType, type ClientPhoto } from "@fitness-app/data-models/entities/Measurement";

import { getPageRange } from "../../../helpers/getPageRange";
import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_MEASUREMENTS_REDUCER_NAME } from "../types";

type Payload = {
  traineeId: string;
  page?: number;
};

export const fetchTraineeBodyPhotos = createAsyncThunk<
  { data: ClientPhoto[]; currentPage: number; totalPages: number },
  Payload,
  AsyncThunkCreator<string>
>(
  `${TRAINEE_MEASUREMENTS_REDUCER_NAME}/fetchTraineeBodyPhotos`,
  async ({ traineeId, page }, { rejectWithValue, getState, extra: { db } }) => {
    const { measurementsPageSize } = getState().traineeMeasurements;

    const { start, stop, currentPage } = getPageRange(page, measurementsPageSize);

    const { error, data, count } = await db
      .from("measurement")
      .select("*", { count: "exact" })
      .order("eventTimestamp", { ascending: false })
      .eq("traineeId", traineeId)
      .in("type", [MeasurementType.ClientPhoto])
      .range(start, stop)
      .limit(measurementsPageSize)
      .returns<ClientPhoto[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return { data: data || [], currentPage, totalPages: count ? Math.ceil(count / measurementsPageSize) : 0 };
  },
);
